import {
    GET_LTO_PURCHASE_ORDER_HISTORY_LIST,
    PURCHASE_ORDER_HISTORY_TAB_ACTIVE,
    UPDATE_LTO_PURCHASE_ORDER_HISTORY_LIST,
    LTO_PURCHASE_ORDER_HISTORY_DETAILS,
    ADD_PROXY_ORDER,
    GET_NOTIFICATION_CHANNEL,
    REMINDER_NOTIFICATION,
    CANCEL_LTO_ORDER,
    CLEAR_LTO_LIST_DATA,
} from 'Actions/ltoPurchaseOrder';
import update from 'immutability-helper';

let initialState = {
    ltoPurchaseOrderHistoryList: {},
    purchaseOrderHistoryTabActive: 0,
    ltoPurchaseOrderHistoryDetails: {},
    notificationChannel: {},
    reminderNotification: {},
    ltoCancelOrder: {},
};

export function ltoPurchaseOrder(state = initialState, action) {
    let payload = {};

    switch (action.type) {
        case GET_LTO_PURCHASE_ORDER_HISTORY_LIST:
            if (action.payload.pageNum <= 1) {
                payload.ltoPurchaseOrderHistoryList = action.payload.data;
            } else {
                payload.ltoPurchaseOrderHistoryList =
                    state.ltoPurchaseOrderHistoryList.concat(
                        action.payload.data,
                    );
            }
            return {...state, ...payload};
        case PURCHASE_ORDER_HISTORY_TAB_ACTIVE:
            return update(state, {
                purchaseOrderHistoryTabActive: action.payload,
            });
        case UPDATE_LTO_PURCHASE_ORDER_HISTORY_LIST:
            payload.ltoPurchaseOrderHistoryList = action.payload;
            return {...state, ...payload};
        case LTO_PURCHASE_ORDER_HISTORY_DETAILS:
            payload.ltoPurchaseOrderHistoryDetails = action.payload.data;
            return {...state, ...payload};
        case ADD_PROXY_ORDER:
            payload = action.payload.data || {};

            return Object.assign({}, state, {addProxyOrder: payload});

        case GET_NOTIFICATION_CHANNEL:
            payload = action.payload.data || {};

            return Object.assign({}, state, {notificationChannel: payload});

        case REMINDER_NOTIFICATION:
            payload = action.payload.data || {};

            return Object.assign({}, state, {reminderNotification: payload});

        case CANCEL_LTO_ORDER:
            payload = action.payload.data || {};

            return Object.assign({}, state, {ltoCancelOrder: payload});

        case CLEAR_LTO_LIST_DATA:
            payload.ltoPurchaseOrderHistoryList = [];
            return {...state, ...payload};
        default:
            return state;
    }
}
